import { Provider } from '@angular/core';
import { NgbPopoverConfig, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';

/**
 * App-wide defaults for ng-bootstrap tooltip/popover windows.
 *
 * `container: 'body'` - left at the ng-bootstrap default, the window is appended as a sibling of its host,
 * so a tooltip on an icon inside a `<label>` inherits the global `label { opacity: 70% }` in styles.scss and
 * renders see-through. The configs are constructed with the default already applied (no post-bootstrap
 * mutation), so there is no ordering dependency. Override per instance with `container`, or give a component
 * its own `NgbTooltipConfig`/`NgbPopoverConfig` provider.
 */
export function provideNgbOverlayDefaults(): Provider[] {
  return [
    {
      provide: NgbTooltipConfig,
      useFactory: () => Object.assign(new NgbTooltipConfig(), { container: 'body' }),
    },
    {
      provide: NgbPopoverConfig,
      useFactory: () => Object.assign(new NgbPopoverConfig(), { container: 'body' }),
    },
  ];
}
